import { render, staticRenderFns } from "./keshi.vue?vue&type=template&id=4831cfb7&scoped=true&"
import script from "./keshi.vue?vue&type=script&lang=js&"
export * from "./keshi.vue?vue&type=script&lang=js&"
import style0 from "./keshi.vue?vue&type=style&index=0&id=4831cfb7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4831cfb7",
  null
  
)

export default component.exports